'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const Formatters=require('../../../../dist-es6/client/formatters');let

FatigueThresholdLineDirective=class FatigueThresholdLineDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['plotArea','verticalAxis','horizontalAxis','fatigueThreshold'];
}

get textBindings(){
return[];
}

get controller(){
return FatigueThresholdLineDirectiveController;
}};let


FatigueThresholdLineDirectiveController=class FatigueThresholdLineDirectiveController{
static get $inject(){return['$scope','$element','$timeout','$window']}

constructor($scope,$element,$timeout,$window){
$scope.$watch('controller.plotArea',()=>{
if(_.exists(this.plotArea)){
this.plotArea.registerPlotter(this);
}
});
}

get _scalesValid(){
return(
_.exists(this.horizontalAxis)&&
_.exists(this.horizontalAxis.scale)&&
_.exists(this.verticalAxis)&&
_.exists(this.verticalAxis.scale));
}

redraw(){
if(!this._scalesValid){
return;
}

let fatigueThresholdGroup=d3.select(this.plotArea.svgElement).append('g').attr({
class:'fatigue-threshold',
transform:`translate(${this.plotArea.dimensions.width}, 0)`});


fatigueThresholdGroup.selectAll('line').
data([{yPos:this.verticalAxis.scale(this.fatigueThreshold)}]).
enter().
append(`line`).
attr({
x1:-this.plotArea.graphAreaDimensions.width,
x2:0,
y1:pointInfo=>pointInfo.yPos,
y2:pointInfo=>pointInfo.yPos,
class:this.class}).

style({
"stroke-width":1,
stroke:'#6A8187'});

}};


module.exports=FatigueThresholdLineDirective;
//# sourceMappingURL=fatigueThresholdLineDirective.js.map
